import styled, { css } from 'styled-components';
import { MDBDropdown, MDBDropdownItem } from 'mdbreact';
import { colors, MediaQuery, styleHelpers } from '../../theme/style-helpers';
import ArrowRightWhite from '../../assets/icons/ArrowRightWhite.svg';
import ArrowRightOrange from '../../assets/icons/ArrowRightOrange.svg';
import ArrowRightBlack from '../../assets/icons/ArrowRightBlack.svg';
import ArrowLeftOrange from '../../assets/icons/ArrowLeftOrange.svg';
import Error from '../../assets/icons/Error.svg';
import { P } from '../../theme/typographySitecore';
import Actions from '../../assets/icons/Actions.svg';
import ChevronDownOrangeSmall from '../../assets/icons/ChevronDownOrangeSmall.svg';
import Row from '../ReactComponent/Row';

export const LoginBanner = styled.div`
    height: 168px;
    top: 372px;
    background: red;
`;

export const ReadyTimeSummary = styled.div`
    margin-bottom: 30px;
    font-style: normal;
    font-weight: normal;
    font-size: 1.4rem;
    line-height: 2rem;
    color: #000000;
`;

export const FieldGroup = styled.div`
    margin-bottom: 58px;
`;

export const ErrorMessage = styled.span`
    font-style: normal;
    padding: 10px 6px;
    align-items: center;
    display: flex;
    font-weight: 500;
    font-size: 1.4rem;
    line-height: normal;
    color:  ${colors.ERROR};
`;

export const Icon = styled.img`
    margin-right: 10px;

    &.right {
        margin-right: 0;
        margin-left: 10px;
    }
`;

export const FormContainer = styled.div`
    width: 100%;
    margin: 0 auto;
`;

export const AddressBlock = styled.div`
    &.with-bg {
        background-color: ${colors.LIGHT_GREY};
        padding: 32px;
        box-shadow: 0px 32px 6px -30px rgba(0, 0, 0, 0.2);
        border-radius: 6px;
        margin-bottom: 32px;
    }
`;

export const FormSummary = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 40px;
    padding-bottom: 40px;

    .hide-date {
        p {
            display: none;
        }
    }
`;

export const InputContainer = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 16px;
`;

export const DateContainer = styled.div`
    max-width: 312px;
`;

export const TimeWrapper = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 40px;

    ${MediaQuery.xLarge(css`
        grid-auto-flow: column;
        grid-template-columns: max-content max-content;
        column-gap: 56px;
        row-gap: 8px;
    `)};
`;

export const TimeError = styled.p`
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 130%;
    color: #D44333;
    margin: 0;
    margin-top: 16px;
    width: 100%;

    ${MediaQuery.xLarge(css`
       width: 350px;
    `)};
`;

export const TimeContainer = styled.div`
    display: grid;
    grid-template-columns: auto max-content;
    column-gap: 12px;
    align-items: end;

    ${MediaQuery.small`
        width: max-content;
    `};
`;

export const TimeDivider = styled.div`
    font-weight: 500;
    font-size: 20px;
    line-height: 150%;
    color: ${colors.BLACK};
    align-self: center;
    padding-top: 24px;
    text-align: center;
`;

export const TimeInputsContainer = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: auto max-content auto;
    column-gap: 8px;

    ${MediaQuery.small`
        grid-template-columns: 104px max-content 104px;
    `}
`;

export const OptionsContainer = styled.div`
    display: grid;
    column-gap: 32px;
    grid-auto-flow: column;
    grid-auto-columns: max-content;
`;

export const AdditionalNotesContainer = styled.div`
    width: 100%;

    ${MediaQuery.small`
        max-width: 423px;
    `}
`;

export const PrimaryButton = styled.button`
    background-color: ${colors.DARK_GREY};
    font-style: normal;
    position: relative;
    font-weight: 500;
    font-size: 1.6rem;
    line-height: normal;
    text-align: center;
    color: ${colors.COOL_GREY};
    padding: 16px 56px;
    border: 1px solid ${colors.DARK_GREY};
    border-radius: 3px;
    margin-left: 0;
    margin-bottom: 10px;
    width: 100%;
    cursor: pointer;
    order: 0;
    float: none;

    &.min-width {
        min-width: 300px;
    }

    &.max-width-200 {
        max-width: 200px;
    }

    ${MediaQuery.medium`
        width: auto;
        margin-left: 16px;
        margin-bottom: 0;
        order: 1;

        &.float-right{
            float: right;
        }
    `}

    .icon {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 17px;
        margin: 0;
        height: 24px;
        width: 24px;
        background: url(${ArrowRightWhite});
        background-size: cover;
    }

    &.submit, &.active {
        background-color: ${colors.BLACK};

        .icon {
            background: url(${ArrowRightOrange});
        }

        &:hover {
            background-color: ${colors.BRAND_ORANGE};
            color: ${colors.BLACK};
            border-color: ${colors.BRAND_ORANGE};

            .icon {
                background: url(${ArrowRightBlack});
            }
        }
    }
`;

export const SecondaryButton = styled.button`
    background-color: ${colors.WHITE};
    position: relative;
    font-style: normal;
    font-weight: 500;
    font-size: 1.6rem;
    line-height: normal;
    text-align: center;
    color: ${colors.BLACK};
    padding: 16px 56px;
    border: 1px solid ${colors.BLACK};
    border-radius: 3px;
    margin-left: 0;
    width: 100%;
    cursor: pointer;

    &.min-width {
        min-width: 300px;
    }


    ${MediaQuery.medium`
        width: auto;
        margin-left: 16px;
    `}

    .icon-left {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 17px;
        margin: 0;
        height: 24px;
        width: 24px;
        background: url(${ArrowLeftOrange});
        background-size: cover;
    }

    .icon-right {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 17px;
        margin: 0;
        height: 24px;
        width: 24px;
        background: url(${ArrowRightOrange});
        background-size: cover;
    }

    &.no-border {
        border: none;
    }

    &:hover {
        border-color: ${colors.BRAND_ORANGE};
    }

    &.hidden {
        display: none;
    }
`;

export const ButtonGroup = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 40px 0px 72px;
    flex-wrap: wrap;
`;

export const SingleButtonContainer = styled(ButtonGroup)`
    justify-content: flex-end;
`;

export const SuccessMessageBox = styled.div`
    text-align: center;
    margin: 32px auto 100px;

    .success-image {
        margin-bottom: 32px;
    }
`;

export const AddItemContainer = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    justify-content: flex-end;
    padding: 18px 8px;
    margin-bottom: 40px;
    &.with-background {
        background-color: ${colors.WHITE};
        border-bottom: 1px solid ${colors.COOL_GREY};

        p {
            margin: 0;
        }
    }

    .hide{
        display: none;
    }
`;

export const AddItem = styled.button`
    background-color: ${colors.WHITE};
    font-style: normal;
    position: relative;
    font-weight: 500;
    font-size: 1.6rem;
    line-height: normal;
    text-align: center;
    color: ${colors.DARK_GREY};
    padding: 17px 34px;
    border: 1px solid ${colors.COOL_GREY};
    border-radius: 3px;
    margin-left: 0;
    margin-bottom: 10px;
    width: 100%;
    cursor: pointer;
    order: 0;

    ${MediaQuery.medium`
        width: auto;
        margin-left: 16px;
        margin-bottom: 0;
        order: 1;
    `}

    &.active {
        background-color: ${colors.BLACK};
        label {
            color: ${colors.WHITE};
        }

        &:hover {
            background-color: ${colors.BRAND_ORANGE};
            color: ${colors.BLACK};
            border-color: ${colors.BRAND_ORANGE};

        }
    }

    .hidden-button {
        display: none;
    }
`;

export const AddItemLabel = styled.label`
    font-style: normal;
    font-weight: 500;
    font-size: 1.6rem;
    line-height: 2.2rem;
    color: ${colors.DARK_GREY};
    margin-bottom: 0;
    margin-left: 8px;
    cursor: pointer;
`;

export const BlockTitle = styled.legend`
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    color: ${colors.BLACK};
    margin: 0;

    span {
        font-weight: 500;
        font-size: 14px;
        color: #757575;
        text-transform: lowercase;
    }
`;

export const AddedItemCard = styled.div`
    background-color: ${colors.LIGHT_GREY};
    padding: 32px;
    box-shadow: 0px 32px 6px -30px rgba(0, 0, 0, 0.2);
    border-radius: 6px;
    width: 100%;
    margin: 40px 0;
    position: relative;
    flex-wrap: wrap;

    .row {
        width: 100%;
    }

    .title-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 24px;
        flex-wrap: wrap;

        p {
            margin: 0;
        }

        > &:nth-child(even) {
            background-color: ${colors.WHITE};
        }
    }

    h2, h3 {
        color: ${colors.DARK_GREY};
    }
`;

export const HelpBox = styled.div`
    margin: 10px;
    background: grey;
`;

export const PageTitle = styled.div`
    font-weight: 300;
    font-size: 4.8rem;
    margin-bottom: 32px;

    &.justified {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    }
`;

export const Title = styled.h1`
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 31px;
    color: ${colors.BLACK};
    margin: 0px;
`;

export const SubTitle = styled.p`
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: ${colors.BLACK};
    margin: 0px;
`;

export const FieldGroupLabel = styled.h2`
    font-style: normal;
    font-size: 18px;
    font-weight: 600;
    line-height: 22px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: no-wrap;
    width: 100%;
    margin: 32px 0px 16px;

    ${MediaQuery.medium`
        margin: 32px 0px 16px;
    `}
`;

export const DisclaimerGroup = styled.div`
    display: flex;
    flex-direction: row;
    align-content: center;
`;

export const DisclaimerNote = styled.h3`
    font-style: normal;
    font-size: 14px;
    color: ${colors.BRAND_ORANGE};
    font-weight: 600;
    line-height: 22px;
    display: flex;
    align-items: center;
    flex-wrap: no-wrap;
    margin: 0;
`;

export const DisclaimerText = styled.p`
    font-style: normal;
    font-size: 14px;
    line-height: 22px;
    display: flex;
    align-items: center;
    flex-wrap: no-wrap;
    margin: 0;
`;

export const CategoryTitle = styled(Title)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: no-wrap;
    width: 100%;
    margin: 40px 0px 32px;

    ${MediaQuery.medium`
        margin: 56px 0px 32px;
    `}
`;

export const DivisionRow = styled.div`
    margin-bottom: 80px;

    .delivery-type {
        .rw-list {
            margin: 0;
        }

        .rw-select-list-label {
            margin-right: 3rem;
            font-size: 1.4rem;
            line-height: 2.1rem;
            display: inline-flex;
            align-items: center;
            position: relative;
            padding-left: 28px;
            cursor: pointer;
            user-select: none;
            flex-wrap:wrap;

            .rw-select-list-input {
                position: absolute;
                opacity: 0;
                cursor: pointer;
                height: 0;
                width: 0;

                &:checked ~ .checkmark {
                    background-color: ${colors.BRAND_ORANGE};

                    &:after {
                        display: block;
                        left: 5px;
                        top: 1px;
                        width: 7px;
                        height: 11px;
                        border: solid ${colors.WHITE};
                        border-width: 0 2px 2px 0;
                        transform: rotate(45deg);
                    }
                }
            }

            .checkmark {
                position: absolute;
                top: 0;
                left: 0;
                height: 21px;
                width: 21px;
                border: 1.5px solid ${colors.BLACK};
                background-color: ${colors.WHITE};
                border-radius: 2px;

                &:after {
                    content: "";
                    position: absolute;
                    display: none;
                }
            }
        }
    }
`;

export const PaymentMethod = styled.div`
    margin: 56px 0;
`;

export const PaymentMethodsContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 24px;
    align-items: flex-start;

    ${MediaQuery.small`
        grid-template-columns: repeat(2, 1fr);
    `};

    ${MediaQuery.medium`
        grid-template-columns: repeat(${({ loggedIn }) => (loggedIn ? 3 : 4)}, 1fr);
    `};
`;

export const InputUnit = styled.div`
    font-size: 18px;
    line-height: 24px;
    margin-top: 45px;
`;

export const MeasurementItemProperty = styled.div`
    height: 56px;
    font-size: 14px;
    line-height: 17px;
`;

export const TextProperty = styled.div`
    font-size:1.4rem;
    margin-bottom: 32px;
    font-weight: 500;

    .title {
        margin-bottom: 10px;
    }

    .justified {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    }

    .normal-weigth {
        font-weight: normal;
    }

    hr {
        border-color: ${colors.GREY_MEDIUM};
    }

    span.capitalize {
        text-transform: capitalize;
    }

    h2.total-title {
        font-size: 1.6rem;
        font-weight: 600;
    }
`;

export const ContentBoxLightGrey = styled.div`
    background-color: ${colors.LIGHT_GREY};
    padding: 32px;
    box-shadow: 0px 32px 6px -30px rgba(0, 0, 0, 0.2);
    border-radius: 6px;
    width: 100%;
    margin: 40px 0;
    position: relative;
    flex-wrap: wrap;

    .title-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 24px;
        flex-wrap: wrap;

        p {
            margin: 0;
        }

        > &:nth-child(even) {
            background-color: ${colors.WHITE};
        }
    }

    h2, h3 {
        color: ${colors.DARK_GREY};
    }
`;

export const LineButton = styled.a`
    display: inline-flex;
    align-items: center;
    font-size: 1.6rem;
    line-height: 2rem;
    font-weight: 500;
    cursor: pointer;
    color: ${colors.BLACK};
    text-decoration: none;

    p {
        margin: 0;
    }

    &:hover {
        p {
            text-decoration: underline;
        }
    }
`;

export const MeasurementTab = styled.div`
    font-weight: 500;
    font-size: 1.6rem;

    ${styleHelpers.mobile`
        width: 100%;

        > div {
            margin-bottom: 0;
        }
    `}

    .rw-list-option {
        ${styleHelpers.mobile`
            width: 50%;
        `}

        .rw-select-list-label {
            background-color: ${colors.COOL_GREY};
            border: 1px solid ${colors.BLACK};
            padding: 16px 41px;
            line-height: 1;
            box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.2);
            margin: 0;
            cursor: pointer;

            ${styleHelpers.mobile`
                justify-content: center;
            `}

            .rw-select-list-input {
                display: none;
            }
        }

        &[aria-checked="true"] {
            .rw-select-list-label {
                background-color: ${colors.WHITE};
                box-shadow: none;
            }
        }
    }
`;

export const PaymentType = styled.div`
    .rw-list-option {
        width: ${({ column }) => `${100 / column}%`};
    }

    .rw-list {
        margin: 0;
    }

    .rw-select-list-label {
        margin-right: 3rem;
        font-size: 1.4rem;
        line-height: 2.1rem;
        display: inline-flex;
        align-items: center;
        position: relative;
        padding-left: 28px;
        cursor: pointer;
        user-select: none;
        flex-wrap:wrap;

        .rw-select-list-input {
            position: absolute;
            opacity: 0;
            cursor: pointer;
            height: 0;
            width: 0;

            &:checked ~ .checkmark {
                background-color: ${colors.BRAND_ORANGE};

                &:after {
                    display: block;
                    left: 5px;
                    top: 1px;
                    width: 7px;
                    height: 11px;
                    border: solid ${colors.WHITE};
                    border-width: 0 2px 2px 0;
                    transform: rotate(45deg);
                }
            }
        }

        .checkmark {
            position: absolute;
            top: 0;
            left: 0;
            height: 21px;
            width: 21px;
            border: 1.5px solid ${colors.BLACK};
            background-color: ${colors.WHITE};
            border-radius: 2px;

            &:after {
                content: "";
                position: absolute;
                display: none;
            }
        }
    }
`;

export const Terms = styled.div`
    margin-bottom: 72px;
`;

export const PickupTime = styled.div`
    display: flex;
    align-items: center;

    .pickup-time {
        margin: 0 10px 0 0;
        width: calc(100% / 3);
    }
    .colon {
        padding-right: 0.8rem;
      }
`;

export const FileUploadContainer = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    justify-content: space-between;
    padding: 18px 8px;
    order: 99;

    &.with-dot {
        margin-bottom: 57px;
        padding: 0;

        &:after {
            content: '';
            width: calc(100% - 200px);
            background-image: linear-gradient(to right, ${colors.DARK_GREY} 33%, rgba(255,255,255,0) 0%);
            background-position: bottom;
            background-size: 6px 2px;
            background-repeat: repeat-x;
            height: 2px;
        }
    }

    &.with-background {
        background-color: ${colors.WHITE};
        border-bottom: 1px solid ${colors.COOL_GREY};

        p {
            margin: 0;
        }
    }
`;

export const FileUpload = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;

    .hidden-button {
        display: none;
    }
`;

export const FileUploadLabel = styled.label`
    font-style: normal;
    font-weight: 500;
    font-size: 1.6rem;
    line-height: 2.2rem;
    color: ${colors.DARK_GREY};
    margin-bottom: 0;
    margin-left: 8px;
`;

export const ItemContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
`;

export const GeneralContainer = styled.div`
    display: grid;
    grid-gap: 32px;
    grid-auto-flow: row;

    ${MediaQuery.medium`
        grid-auto-flow: column;
    `}
`;

export const BillOfLaddingRadioContainer = styled(GeneralContainer)`
    grid-auto-columns: max-content;
    grid-auto-flow: column;
`;

export const UseQuoteOrShipmentNumberContainer = styled(GeneralContainer)`
    grid-auto-flow: column;
    grid-auto-columns: minmax(min-content, 500px) auto;

    h3 {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 24px;
    }

    .quoteOrShipmentRadios {
        display: flex;
        margin-bottom: 5em;

        div:first-child {
            margin-bottom: 0;
        }
    }

    .previousQuotesOrShipmentsLink {
        cursor: pointer;
        font-family: Montserrat;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 21px;
        margin-top: 3em;
        letter-spacing: 0.01em;
        text-decoration: underline;
    }

    .errorMessage {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 17px;
        color: #CE0505;
    }
`;

export const BillingAccountsContainer = styled.div`
    display: grid;
    grid-gap: 16px;
`;

export const BillToGuide = styled.div`
    font-size: 1.4rem;
    line-height: 2.2rem;
    padding: 16px;
    h4 {
        font-weight: 700;
        font-size: 1.6rem;
        margin-bottom: 8px;
    }
    p {
        margin: 0;
    }
    dl {
        display: grid;
        grid-template-columns: auto 1fr;
        gap: 4px 12px;
        margin: 8px 0 0 0;
    }
    dt {
        white-space: nowrap;
    }
    dd {
        margin: 0;
    }
`;

export const UseQuoteOrShipmentNumberHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-content: center;
`;

export const ButtonDiv = styled.div`
    gap: 32px;
    padding-top: 40px;
    padding-left: 0px;

    div:nth-child(1) {
        ${styleHelpers.mobile`
            order: 1;
        `}
    }
`;

export const ModalButtonContainer = styled.div`
    display: grid;
    grid-gap: 32px;
    grid-auto-flow: column;
`;

export const ModalTitle = styled.div`
    font-size:2.5rem;
    padding-top:34px;
    padding-bottom: 25px;
`;

export const ModalBody = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 50px;
    font-size: 1.5rem;
    text-align: center;
`;

export const ErrorIcon = styled.img.attrs(() => ({ src: Error }))`
  margin-right: 10px;
`;

export const Close = styled.div`
    position: absolute;
    right: 32px;
    top: 32px;
    width: 32px;
    height: 32px;
    opacity: 0.3;
    cursor:pointer;

    &:hover{
        opacity: 1;
    }

    &:before, &:after{
        position: absolute;
        left: 15px;
        content: ' ';
        height: 33px;
        width: 2px;
        background-color: #333;
    }

    &:before {
        transform: rotate(45deg);
    }

    &:after{
        transform: rotate(-45deg);
    }
`;

export const UploadDocumentsSubHead = styled.div`
    p {
        font-size: 14px;
        font-weight: 400;

        span {
            font-weight: bold;
            color: ${colors.ORANGE_SHADES_DARK1};
        }
    }
`;

export const UploadedDocumentsSummary = styled(P)`
  margin-bottom: 32px;
`;

export const UploadedDocumentsInformation = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 32px;

    p {
        margin-bottom: 0px;
    }

    ${Icon} {
        margin-right: 0px;
    }
`;

export const Step6TopContainer = styled.div`
    display: flex;
    justify-content: space-between;
    margin: 40px 0;
    flex-direction: column;

    ${MediaQuery.small`
    flex-direction: row;
    `};

    ${MediaQuery.large`
    margin: 0;
    margin-bottom: 32px;
    `}
`;

export const StepTopLeftContainer = styled.div`
    display: grid;
    grid-gap: 8px;
`;

export const Step5TopContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 16px 0px 8px;
    gap: 20px;
    margin-top: 20px;

    button {
        width: 100%;
    }

    ${MediaQuery.medium`
        justify-content: space-between;
        align-items: center;
        flex-direction: row;
        gap: 0;

        button {
            width: fit-content;
        }
    `}

    ${MediaQuery.large`
        margin-top: 0;
    `}
`;

export const Step5Title = styled.p`
    font-size: 24px;
    font-weight: 500;
    line-height: 31px;
    letter-spacing: 0em;
    text-align: left;
    margin: 0px;
`;

export const Step5SubTitle = styled.p`
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: ${colors.BLACK};
    margin: 0px;
`;

export const LastActions = styled(Row)`
    margin-top: 5px;
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
        position: absolute;
        left: 67%;
     }

    .dropdown {
        margin-top: 5px;
        width: 100%;

        .btn {
            width: 100%;
            position: relative;
            font-style: normal;
            font-weight: 500;
            font-size: 1.6rem;
            line-height: normal;
            text-align: center;
            color: ${colors.BLACK};
            background: ${colors.WHITE};
            border: 1px solid ${colors.BLACK};
            padding: 16px 56px;
            border-radius: 3px;
            height: 52px;
            @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
                width:${({ msButtonWidth }) => (msButtonWidth || '100%')};
             }
        }
        .dropdown-menu{
            width: 100%;
            @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
                width:auto;
             }
        }
        .icon {
            position: absolute;
            top: 50%;
            right: 17px;
            transform: translateY(-50%);
            height: 24px;
            width: 24px;
            background-size: cover;
            ${({ iconSrc }) => (iconSrc ? `background: url(${iconSrc})` : '')}
        }

        .icon-more-options {
            background: url(${Actions});
        }
    }
`;

export const LastActionsContainer = styled.div`
    display: grid;
    grid-gap: 20px;
    grid-auto-flow: column;
    justify-content: flex-end;
    width: 100%;

    >button:nth-child(1), >button:nth-child(2) {
        width: 100%;
        position: relative;
        font-style: normal;
        font-weight: 500;
        font-size: 1.6rem;
        line-height: normal;
        text-align: center;
        color: ${colors.BLACK};
        background: ${colors.WHITE};
        padding: 16px 24px;
        height: 52px;
        @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
            width:${({ msButtonWidth }) => (msButtonWidth || '100%')};
        }
    }
    >button:nth-child(3) {
        height: 52px;
    }


    .dropdown {
        width: 100%;
        .btn {
            width: 100%;
            position: relative;
            font-style: normal;
            font-weight: 500;
            font-size: 1.6rem;
            line-height: normal;
            text-align: center;
            color: ${colors.BLACK};
            background: ${colors.WHITE};
            white-space: nowrap;
            border: 1px solid ${colors.BLACK};
            border-radius: 1px !important;
            padding: 16px 24px;
            padding-right: 56px;
            border-radius: 3px;
            height: 52px;

            @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
                width:${({ msButtonWidth }) => (msButtonWidth || '100%')};
             }
        }
        .dropdown-menu {
            width: 100%;
            @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
                width:auto;
             }
        }
        .icon {
            position: absolute;
            top: 50%;
            right: 17px;
            transform: translateY(-50%);
            height: 14px;
            width: 14px;
            background-size: cover;
            ${({ iconSrc }) => (iconSrc ? `background: url(${iconSrc})` : '')}
        }

        .icon-more-options {
            background: url(${ChevronDownOrangeSmall});
        }
    }
`;

export const ButtonContainer = styled.div`
    display: none;
    grid-gap: 20px;
    grid-auto-flow: column;
    justify-content: flex-end;

    ${MediaQuery.xLarge(css`
        display: grid;
    `)}

    >button:nth-child(1), >button:nth-child(2) {
        width: 100%;
        position: relative;
        font-style: normal;
        font-weight: 500;
        font-size: 1.6rem;
        line-height: normal;
        text-align: center;
        color: ${colors.BLACK};
        background: ${colors.WHITE};
        padding: 16px 24px;
        height: 52px;
        @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
            width:${({ msButtonWidth }) => (msButtonWidth || '100%')};
        }
    }

`;

export const NeqCheckboxContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-content: center;
`;

export const Container = styled.div`
    padding: 20px;
    margin: 0 auto;

    ${MediaQuery.xLarge(css`
        padding: 60px;
    `)}
`;

export const PageDescription = styled.p`
    margin: 0;
    font-weight: 400;
    font-size: 14px;
    line-height: 130%;
    letter-spacing: 0.01em;
    color: ${colors.BLACK};
`;

export const StyledMDBDropdown = styled(MDBDropdown)`
    & .dropdown-menu {
        padding: 15px;
        background-color: ${colors.LIGHT_GREY} !important;
        cursor: default;
        width: 120% !important;
        >div {
            display: grid;
            grid-gap: 24px;
        }
        &.label-type{
            width: 170% !important;
        }
        ${MediaQuery.xLarge(css`
            width: 100% !important;
        `)}
    }
`;

export const DropdownItem = styled(MDBDropdownItem)`
    display: flex !important;
    align-items: center !important;
    padding: 0px !important;
    font-size: 14px;
    font-weight: 500 !important;
    line-height: 18px;
    letter-spacing: 0em;
    cursor: pointer;

    &:enabled {
        color: ${colors.BLACK} !important;
    }

    &:disabled {
        color: ${colors.DARK_GREY} !important;
    }

    &:hover {
        path {
            fill: ${colors.BRAND_ORANGE};
        }
        p {
            color: ${colors.BRAND_ORANGE};
        }
    }

    ${MediaQuery.xLarge(css`
        &.hideMobile {
            display: none !important;
        }
    `)}
`;

export const DropdownItemIcon = styled.div`
    width: 20px;
    height: 20px;
    background: url( ${({ iconSrc }) => iconSrc});
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    margin: 0;
    margin-right: 8px;
`;

export const IconWrapper = styled.div`
    display: flex;
    justify-content: center;
    width: 25px;
    svg {
        margin-right: 8px;
    }
`;

export const DropdownText = styled.p`
    margin: 0;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    letter-spacing: 0em;
`;
